import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { ErrorPopup } from "../../../../ui/organisms/errorPopup"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { RightBar } from "../../../../ui/organisms/rightBar"
import { SuccessPopup } from "../../../../ui/organisms/successPopup"
import { DepartureProtocolValidation, GetDepartureProtocolById, resetDepartureProtocolCreationStatus, resetDepartureProtocols } from "../slice"
import { NewDepartureLeft } from "./newDepartureLeft"
import { NewDepartureRight } from "./newDepartureRight"

export function AddDepartureProtocol() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const departureProtocolState = useAppSelector(state => state.departureProtocol)

    useEffect(() => {
        if (departureProtocolState.departureProtocolCreationStatus === 'successfully' &&
            departureProtocolState.departureProtocolCreationResponse !== undefined
        ) {
            dispatch(GetDepartureProtocolById(departureProtocolState.departureProtocolCreationResponse))
        }
    }, [departureProtocolState.departureProtocolCreationStatus])

    return (
        <Layout
            menuItem={MenuItems.PROTOCOLLO}
            breadcrumbItems={['Dashboard', 'Gestione Protocollo', 'Partenza']}
            noPaddingLat
            headerLabel="Nuovo Protocollo Partenza"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/departureProtocol')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end gap-2">
                    <ButtonComponent
                        variant='solid'
                        color='orange'
                        size='sm'
                        iconPosition='off'
                        label='Salva protocollo'
                        onClick={() => { dispatch(DepartureProtocolValidation(departureProtocolState.departureProtocolCreationRequest)) }}
                        disabled={
                            departureProtocolState.departureProtocolCreationStatus === 'loading' ||
                            !departureProtocolState.departureProtocolCreationRequest.headQuarter ||
                            !departureProtocolState.departureProtocolCreationRequest.protocolDate ||
                            !departureProtocolState.departureProtocolCreationRequest.receiver ||
                            !departureProtocolState.departureProtocolCreationRequest.departureObjectId
                        }
                    />
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"outline"}
                        label="Nuovo Protocollo Entrata"
                        color={"gray"}
                        onClick={() => {
                            dispatch(resetDepartureProtocols())
                            window.location.reload();
                        }}
                    />
                </div>
            }
        >
            <div className="bg-brandPrimary-100" style={{ display: 'flex', height: '100%' }}>
                <div className="w-[100%] flex flex-col gap-[16px] filter bg-brandPrimary-200" style={{ flex: 0.7, padding: '24px 24px 24px 24px', borderTopRightRadius: '20px' }}>
                    <SuccessPopup
                        message="Dati salvati correttamente."
                        active={departureProtocolState.departureProtocolCreationStatus === 'successfully'}
                        onClose={() => dispatch(resetDepartureProtocolCreationStatus())}
                    />
                    <ErrorPopup
                        message="Errore durante il salvataggio dei dati."
                        active={departureProtocolState.departureProtocolCreationStatus === 'failed'}
                        onClose={() => dispatch(resetDepartureProtocolCreationStatus())}
                    />
                    <NewDepartureLeft />
                </div>
                <div className="bg-brandPrimary-100" style={{ flex: 0.3 }}>
                    <RightBar disabled={!departureProtocolState.fromCreationToUpdate}>
                        <NewDepartureRight />
                    </RightBar>
                </div>
            </div>
        </Layout>
    )
}